import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=c2c020c4&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2c020c4')) {
      api.createRecord('c2c020c4', component.options)
    } else {
      api.reload('c2c020c4', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=c2c020c4&", function () {
      api.rerender('c2c020c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22iLSi91dX5R6/JS/comp/ImgFallback2.vue"
export default component.exports